import { configureStore } from "@reduxjs/toolkit";
import RootSlice from "./root";
import ConfigurationFOcus10 from "./configuration-focus10";

export const store = configureStore({
  reducer: {
    root: RootSlice,
    configurationF10: ConfigurationFOcus10,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
